export const HTTP_ERROR_MESSAGES: Record<number, string> = {
    400: "Не удалось выполнить действие. Проверьте данные и попробуйте снова.",
    401: "Сессия истекла. Войдите в систему повторно.",
    403: "У вас нет прав для этого действия.",
    404: "Данные не найдены. Возможно, они были удалены или недоступны.",
    405: "Данная операция не поддерживается.",
    408: "Сервер не ответил вовремя. Повторите попытку.",
    409: "Операция не может быть выполнена из-за конфликта данных.",
    413: "Загружаемый файл слишком большой.",
    415: "Сервер не поддерживает формат отправленных данных.",
    422: "Проверьте правильность заполнения данных.",
    429: "Слишком много запросов. Повторите попытку позже.",
    500: "На сервере произошла ошибка. Попробуйте позже.",
    502: "Сервер временно недоступен.",
    503: "Сервис временно недоступен. Повторите попытку позже.",
    504: "Сервер не ответил вовремя. Повторите попытку.",
};
